import { useCallback, useRef } from 'react'
import { asErrorMessage } from './cartMutationUtils'

type Params = {
  setBusy: (value: boolean) => void
  setError: (value: string) => void
}

export const useCartMutationRunner = ({ setBusy, setError }: Params) => {
  const lastErrorRef = useRef('')

  const setMutationError = useCallback(
    (message: string) => {
      const normalizedMessage = message.trim() || 'Errore gestione carrello'
      lastErrorRef.current = normalizedMessage
      setError(normalizedMessage)
    },
    [setError],
  )

  const clearMutationError = useCallback(() => {
    lastErrorRef.current = ''
    setError('')
  }, [setError])

  const runMutation = useCallback(
    async (operation: () => Promise<void>) => {
      setBusy(true)
      clearMutationError()
      try {
        await operation()
        return true
      } catch (error) {
        setMutationError(asErrorMessage(error))
        return false
      } finally {
        setBusy(false)
      }
    },
    [clearMutationError, setBusy, setMutationError],
  )

  return {
    runMutation,
    setMutationError,
    clearMutationError,
    getLastError: () => lastErrorRef.current,
  }
}
